export default __webpack_public_path__ + "static/media/image4-4.f5e6a79a.png";